module.exports = __webpack_public_path__ + "img/MTABAPPSPO2.567e26f2.jpg";